import { type CountryCode } from 'libphonenumber-js'

export { RCS_SUPPORTED_COUNTRIES, type IRcsSupportedCountry } from 'entities/Rcs'

export const US_COUNTRY_ISO_CODE: CountryCode = 'US'

export const BUSINESS_NAME_MAX_LENGTH = 120
export const EIN_MAX_LENGTH = 9
export const PUBLIC_CORPORATION_COMPANY_TYPE = 'public_corporation'
